// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5a75f1a6","239":"e7c5177c","286":"e826dfd2","453":"0416336b","465":"8f956ddf","732":"bd8d557b","977":"ebc18506"}[chunkId] + ".chunk.js";
};